// Persian / Farsi — RTL
export const fa = {
  'nav.solutions': 'راهکارهای پخش زنده',
  'nav.streamTemplates': 'الگوهای پخش',
  "nav.prepare": "آماده‌سازی",
  "nav.events": "رویدادها و پخش زنده",
  "nav.featurePresets": "تنظیمات قابلیت‌ها",
  "nav.interact": "تعامل",
  "nav.boards": "تخته‌های تعاملی",
  "nav.measure": "گزارش‌ها و تجارت",
  "nav.menu": "باز کردن منو",
  "nav.closeMenu": "بستن منو",

  'app.name':           'Kardolive',
  'app.tagline':        'پرتال مشتری',
  'app.signOut':        'خروج',

  'login.email':        'ایمیل',
  'login.password':     'گذرواژه',
  'login.signIn':       'ورود',
  'login.signingIn':    'در حال ورود…',
  'login.failed':       'ورود ناموفق',
  'login.newAccount':   'تازه‌وارد در Kardolive؟',
  'login.createAccount':'ایجاد حساب رایگان ←',

  'nav.workspace':      'فضای کاری',
  'nav.templates':      'الگوها',
  'nav.live':           'پخش زنده',
  'nav.rooms':          'اتاق\u200cها و گفتگو',
  'nav.content':        'محتوا',
  'nav.developer':      'توسعه‌دهنده',
  'nav.account':        'حساب کاربری',

  'nav.overview':       'نمای کلی',
  'nav.projects':       'پروژه‌ها',
  'nav.chat':           'کنسول چت',
  'nav.sessions':       'جلسات',
  'nav.streams':        'پخش زنده',
  'nav.studio':         'استودیو',
  'nav.recordings':     'ضبط‌ها',
  'nav.apiKeys':        'کلیدهای API',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'تستر Webhook',
  'nav.networkTest':    'تست شبکه',
  'nav.embed':          'ابزارک‌های جاسازی',
  'nav.sdk':            'SDK و مستندات',
  'nav.docs':           'مستندات توسعه‌دهنده',
  'nav.analytics':      'تحلیل‌ها',
  'nav.settings':       'تنظیمات',

  'overview.welcome':       'خوش آمدید، {name}',
  'overview.plan':          '{tenant} · پلن {plan}',
  'overview.newStream':     'پخش جدید',
  'overview.kpi.live':           'هم‌اکنون زنده',
  'overview.kpi.live.broadcasting': 'پخش در جریان',
  'overview.kpi.live.nothing':    'پخش زنده‌ای نیست',
  'overview.kpi.total':           'کل پخش‌ها',
  'overview.kpi.total.sub':       'در تمام زمان‌ها',
  'overview.kpi.sessions':        'جلسات · ۳۰ روز',
  'overview.kpi.sessions.sub':    'رویدادهای انتشار',
  'overview.kpi.recordings':      'ضبط‌ها',
  'overview.kpi.recordings.sub':  'آماده پخش',
  'overview.recentStreams':       'پخش‌های اخیر',
  'overview.recentSessions':      'جلسات اخیر',
  'overview.viewAll':             'مشاهده همه ←',
  'overview.empty.title':         'هنوز پخشی نیست',
  'overview.empty.body':          'برای شروع پخش، اولین پخش خود را ایجاد کنید.',
  'overview.empty.action':        'ایجاد پخش',
  'overview.noSessions':          'هنوز جلسه‌ای نیست',

  'status.live':        'زنده',
  'status.idle':        'غیر فعال',
  'status.ended':       'پایان یافت',
  'status.archived':    'بایگانی شده',

  'common.save':        'ذخیره',
  'common.cancel':      'لغو',
  'common.delete':      'حذف',
  'common.edit':        'ویرایش',
  'common.create':      'ایجاد',
  'common.confirm':     'تأیید',
  'common.loading':     'در حال بارگذاری…',
  'common.error':       'خطا',
  'common.retry':       'تلاش مجدد',

  // Dashboard navigation and account controls.
  "nav.skipContent": "رفتن به محتوای صفحه",
  "nav.scenarios": "سناریوهای کاربرد",
  "nav.premieres": "نمایش‌های نخست",
  "nav.clips": "کلیپ‌ها",
  "dashboard.account": "حساب",
  "dashboard.language": "زبان",
  "dashboard.appearance": "ظاهر",
  "nav.allStreams": "همهٔ پخش‌ها",
  "nav.destinations": "مقصدهای پخش",
  "nav.ecommerce": "تجارت الکترونیک",
  "nav.products": "محصولات",
  "nav.services": "خدمات",
  "nav.collections": "مجموعه‌ها",
  "nav.orders": "سفارش‌ها",
  "nav.commerceSettings": "تنظیمات فروش",
  "nav.engagement": "تعامل",
  "theme.light": "تغییر به حالت روشن",
  "theme.dark": "تغییر به حالت تیره",
  "role.owner": "مالک",
  "role.admin": "مدیر",
  "role.member": "عضو",
  "role.viewer": "بیننده",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "فعال",
  "streams.archived": "بایگانی‌شده",
  "streams.monitor": "پایش منابع پخش",
  "streams.create": "ایجاد پخش زنده",
  "streams.list": "فهرست",
  "streams.grid": "شبکه",
  "streams.view": "نمایش پخش‌ها",
  "streams.searchLabel": "جستجوی رویدادها",
  "streams.searchHint": "جستجوی نام رویداد",
  "streams.solutionFilter": "فیلتر رویدادها بر اساس نوع",
  "streams.statusFilter": "فیلتر رویدادها بر اساس وضعیت",
  "streams.dateFilter": "فیلتر بر اساس تاریخ ایجاد",
  "streams.allSolutions": "همهٔ انواع",
  "streams.custom": "تنظیمات موجود یا سفارشی",
  "streams.allStatuses": "همهٔ وضعیت‌ها",
  "streams.anyTime": "همهٔ تاریخ‌های ایجاد",
  "streams.last7": "ایجادشده در ۷ روز گذشته",
  "streams.last30": "ایجادشده در ۳۰ روز گذشته",
  "streams.count": "نمایش {shown} از {total} رویداد",
  "streams.noMatch": "رویدادی مطابق فیلترها پیدا نشد.",
  "streams.clearFilters": "پاک کردن فیلترها",
  "streams.refreshFailed": "فهرست پخش‌ها به‌روز نشد",
  "streams.loadFailed": "بارگیری پخش‌ها ممکن نشد",
  "streams.stale": "آخرین فهرست بارگیری‌شده نمایش داده می‌شود. ممکن است وضعیت‌ها تغییر کرده باشند.",
  "streams.connectionHint": "اتصال را بررسی کنید و فهرست را دوباره بارگیری کنید.",
  "streams.retrying": "در حال تلاش دوباره…",
  "streams.retry": "تلاش دوباره",
  "streams.restoreFailed": "بازیابی پخش ممکن نشد",
  "streams.restoreHint": "پیش از تلاش دوباره، اتصال را بررسی و فهرست را به‌روز کنید تا وضعیت جدید را ببینید.",
  "streams.unused": "پخش‌های استفاده‌نشده: {count}",
  "streams.unusedHint": "هیچ پخش یا بازپخشی وجود ندارد. برای مرتب کردن فهرست بایگانی کنید؛ چیزی حذف نمی‌شود.",
  "streams.reviewArchive": "بررسی و بایگانی",
  "streams.loading": "در حال بارگیری پخش‌ها…",
  "streams.archiveEmpty": "بایگانی خالی است. پخش‌های بایگانی‌شده و بازپخش‌هایشان تا زمان بازیابی اینجا می‌مانند.",
  "streams.restore": "بازیابی",
  "streams.firstTitle": "اولین پخش خود را ایجاد کنید",
  "streams.firstBody": "تنظیمات فروش، کلاس یا خدمات را انتخاب کنید یا با پخش خالی شروع کنید. از مرورگر، تلفن یا OBS پخش کنید.",
  "streams.blank": "پخش خالی",
  "streams.broadcasts": "دفعات پخش: {count}",
  "streams.replays": "بازپخش‌ها: {count}",
  "streams.sessions": "جلسه‌ها: {count}",
  "streams.recordings": "ضبط‌ها: {count}",
  "streams.mode.BROADCAST": "پخش",
  "streams.mode.LOW_LATENCY": "تأخیر کم",
  "streams.mode.REALTIME": "بی‌درنگ",
  "streams.key": "کلید",
  "streams.archiveTitle": "بایگانی پخش‌های استفاده‌نشده",
  "streams.archiveHint": "این پخش‌ها هرگز آغاز نشده‌اند. هر زمان می‌توانید از زبانهٔ بایگانی‌شده آن‌ها را بازیابی کنید.",
  "streams.archiveFailed": "بایگانی {count} پخش ممکن نشد؛ شاید پخش زنده را آغاز کرده‌اند. بقیه بایگانی شدند.",
  "streams.archiving": "در حال بایگانی…",
  "streams.archiveCount": "بایگانی {count} مورد",
  "streamType.webinar": "وبینارهای تجاری و معرفی محصولات",
  "streamType.classroom": "کلاس و تدریس خصوصی",
  "streamType.training": "آموزش سازمانی",
  "streamType.conference": "همایش‌ها و نمایشگاه‌ها",
  "streamType.shopping": "خرید زنده",
  "streamType.auction": "حراج زنده",
  "streamType.consultation": "مشاوره خصوصی",
  "streamType.creator": "پخش زنده سازندگان و انجمن‌ها",
  "streamType.audio": "اتاق‌های صوتی و پادکست",
  "streamType.sports": "ورزش و ورزش الکترونیکی",
  "streamType.performance": "کنسرت‌ها و اجراها",
  "streamType.community": "مراسم مذهبی و جمع‌آوری کمک",
  "streamType.tour": "بازدیدها و نمایش‌های معرفی",
  "streamType.fitness": "تناسب اندام و کارگاه‌ها",
  "streamType.public-meeting": "اخبار و نشست‌های عمومی",
  "streamType.continuous": "کانال‌ها و دوربین‌های پیوسته",
  "streams.close": "بستن",
};
